import { LogManager } from '../../../../common/port/log/log.manager.port';
import { AccountAverageWorkingHoursSummaryAggregateRootMapper } from '../../../../infrastructure/mappers/org-metrics/working-hours/account-average-working-hours-summary.aggregate-root.mapper';
import { GetAccountAverageWorkingHoursSummaryRequestDto } from '../../../dtos/org-metrics/working-hours/get-account-average-working-hours-summary.request.dto';
import { GetAccountAverageWorkingHoursSummaryResponseDto } from '../../../dtos/org-metrics/working-hours/get-account-average-working-hours-summary.response.dto';
import { GetAccountAverageWorkingHoursSummaryQuery } from '../../../queries/org-metrics/working-hours/get-account-average-working-hours-summary.query';

export class GetAccountAverageWorkingHoursSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountAverageWorkingHoursSummaryQuery,
    protected readonly mapper: AccountAverageWorkingHoursSummaryAggregateRootMapper
  ) {}

  async get(
    props: GetAccountAverageWorkingHoursSummaryRequestDto
  ): Promise<GetAccountAverageWorkingHoursSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetAccountAverageWorkingHoursSummaryController.get encountered an error ${error}`
      );
    }
  }
}
